import React, { useEffect, useState } from 'react'
import { Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { registerErrorNotification } from '../Apis/axiosInterceptor/axiosInstance'
// This component is mounted outside <Admin>, so it has no react-admin i18n context and
// useTranslate() would return the raw key. Use the provider directly — it translates against
// the current locale.
import i18nProvider from '../react-admin/providers/i18nProvider'

// Backend validation messages (English) → i18n key, so the toast can be shown in the user's
// language. Keys must match the exact ValidationException text from the backend.
const BACKEND_MESSAGE_KEYS = {
  "Auto-start can't be enabled when the start time is in the past.":
    'ra.errorMessages.autoStartPastStart',
  "The start time can't be in the past while auto-start is enabled.":
    'ra.errorMessages.startPastAutoStartOn',
  "Auto-stop can't be enabled when the end time is in the past.":
    'ra.errorMessages.autoStopPastEnd',
  "The end time can't be in the past while auto-stop is enabled.":
    'ra.errorMessages.endPastAutoStopOn',
  'A livestream must be at least 30 minutes long.': 'ra.errorMessages.livestreamMinDuration',
}

const ErrorNotificationHandler = () => {
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    statusCode: null,
  })

  useEffect(() => {
    // Register the callback when component mounts
    registerErrorNotification(({ message, statusCode }) => {
      setNotification({
        open: true,
        message,
        statusCode,
      })
    })

    // Optional: Cleanup on unmount (though usually this component stays mounted)
    return () => {
      registerErrorNotification(null)
    }
  }, [])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setNotification((prev) => ({ ...prev, open: false }))
  }

  // Server (5xx) / network errors are genuine failures → red; client/validation errors (4xx)
  // are user-fixable → yellow warning.
  const isServerError = notification.statusCode >= 500
  const severity = !notification.statusCode || isServerError ? 'error' : 'warning'

  // 5xx bodies can carry internal/stack details — never surface them. Show a generic message.
  const displayMessage = isServerError
    ? i18nProvider.translate('ra.errorMessages.serverError')
    : BACKEND_MESSAGE_KEYS[notification.message]
      ? i18nProvider.translate(BACKEND_MESSAGE_KEYS[notification.message])
      : notification.message

  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={severity} variant='filled'>
        {displayMessage}
      </Alert>
    </Snackbar>
  )
}

export default ErrorNotificationHandler
